/**
 * Moya reveal — Prestige-style scroll entrance (Motion One via vendor importmap).
 * Usage:
 *   <moya-reveal reveal-on-scroll="true">…children…</moya-reveal>
 * Children stagger in with fade + translateY when the block enters the viewport.
 */
import { animate, inView, stagger } from 'vendor';

const MOTION_SAFE = '(prefers-reduced-motion: no-preference)';

class MoyaReveal extends HTMLElement {
  connectedCallback() {
    if (this.getAttribute('reveal-on-scroll') !== 'true') {
      return;
    }

    if (!window.matchMedia(MOTION_SAFE).matches) {
      this.style.opacity = '1';
      return;
    }

    inView(this, this.#reveal.bind(this), { margin: '-50px 0px' });
  }

  #reveal() {
    this.style.opacity = '1';

    const items = Array.from(this.children);
    if (items.length === 0) {
      return;
    }

    const duration = Number(this.getAttribute('reveal-duration') || 0.25);
    const staggerDelay = Number(this.getAttribute('reveal-stagger') || 0.1);
    const distance = this.getAttribute('reveal-distance') || '30px';

    animate(
      items,
      {
        opacity: [0, 1],
        transform: [`translateY(${distance})`, 'translateY(0)'],
      },
      {
        duration,
        delay: stagger(staggerDelay, { easing: 'ease-out' }),
        easing: 'ease',
      }
    );
  }
}

if (!window.customElements.get('moya-reveal')) {
  window.customElements.define('moya-reveal', MoyaReveal);
}
